<template>
  <div class="terms">
    Terms of Uses <br />
    <br />
    <!-- eslint-disable -->
    Chapter 1 General Provisions <br />
    (Purpose of this Term of Uses)<br />
    Article 1 Brain Sleep Inc. (hereinafter referred to as the "Company") has
    established the Terms of Use for "Sleep Deviation Score for Biz"
    (hereinafter referred to as the "Terms") and provides the "Sleep Deviation
    Score for Biz" (hereinafter referred to as the "Service") based on the
    Terms.<br />
    (Changes to the Terms)<br />
    Article 2 In the event that the Company changes all or part of the Terms,
    the Company shall obtain the prior consent of the user. However, this shall
    exclude cases where the change in the Terms is compatible with the general
    interests of the user and where the change in the Terms does not contravene
    the purpose for which the contract was made, and where the change is
    reasonable in light of the necessity of the change, the appropriateness of
    the content after the change, the existence of a provision that the change
    may be made, the content of the change, and other circumstances pertaining
    to the change.<br />
    (Definition of terms)<br />
    Article 3 In the Terms, the following terms shall have the following
    meanings.<br />
    Term / Meaning of the terms<br />
    (1) "Telecommunications facilities" means machines, appliances, lines and
    other electrical facilities for conducting telecommunications.<br />
    (2) "Self-operated terminal facilities" means terminal facilities used by
    the user.<br />
    (3) "Sleep Deviation Score for Biz" means a service that provides
    applications, etc. for judging sleep quality through server facilities and
    other telecommunication facilities installed by the Company.<br />
    (4) User: A person who uses Sleep Deviation Score for Biz to judge the
    quality of his/her sleep.<br />
    (5) User ID: A combination of arbitrary letters, numbers, etc. specified by
    our Company to identify users.<br />
    <br />
    Chapter 2 Provision of the Service<br />
    (Contents of the Service)<br />
    Article 4 Although we review the contents of the Service from time to time,
    we do not warrant that the Service will be free from factual or legal
    defects, including, but not limited to, defects in safety, reliability,
    accuracy, completeness, effectiveness, fitness for a particular purpose,
    security, errors or bugs, or infringement of rights.<br />
    <br />
    Chapter 3 Use<br />
    (Prohibition of Transfer of Rights)<br />
    Article 5 The right to receive this service belongs only to the user, and
    the right to receive this service may not be transferred, succeeded, sold,
    or pledged to a third party.<br />
    <br />
    Chapter 4 Prohibited Acts<br />
    (Prohibition of Business Activities)<br />
    Article 6 The User may not re-provide all or part of the Service, whether
    for a fee or free of charge.<br />
    (Copyright)<br />
    Article 7 All intellectual property rights, including copyrights, patent
    rights, trademark rights, and know-how, relating to any and all goods
    provided by the Company to Users in this Service, including the Terms of
    Use, various software, handling manuals, websites, mail magazines, etc,
    shall belong to the Company or to any person who permits the Company to use
    such goods.<br />
    ２　The User shall handle the goods mentioned in the preceding paragraph as
    follows.<br />
    (1) Shall not use for any purpose other than the purpose of use of the
    Service.<br />
    (2) Shall not copy, modify, edit, reverse engineer, decompile, or
    disassemble the software.<br />
    (3) Shall not lend, transfer, or mortgage the Software to any third party,
    whether or not for commercial purposes.<br />
    (4) Shall not to delete or change the copyright notice displayed by the
    Company or the Company's contracted service providers that are indispensable
    for the provision of the Service.<br />
    <br />
    Chapter 5 Suspension of the Service<br />
    (Discontinuation of the Service)<br />
    Article 8 The Company may, at its discretion, discontinue the use of all or
    part of the Service at any time. However, this shall be done after prior
    notification within our website (https://suiminhensachi.com/).<br />
    ２　When the Company suspends the use of the Service pursuant to the
    preceding paragraph, the Company shall make it known in advance through the
    Internet or any other method the Company deems appropriate. However, this
    shall not apply in the event of an unavoidable emergency.<br />
    (Suspension of the Service)<br />
    Article 9 The Company may, at its discretion, suspend the use of all or part
    of the Service at any time. However, this shall be done after prior
    notification within our website (https://suiminhensachi.com/).<br />
    (Termination of Provision of the Service)<br />
    Article 10 The Company may terminate the provision of all or part of the
    Service at any time at its discretion. However, we shall notify you at least
    30 days prior to the termination date in our website
    (https://suiminhensachi.com/).<br />
    <br />
    Chapter 6 Fee<br />
    (Fee)<br />
    Article 11 The Service provided by the Company is for a fee. The specific
    amount shall be determined in a separate individual contract.<br />
    <br />
    Chapter 7 Compensation for Damages<br />
    (Limitation of Liability)<br />
    Article 12 The Company shall not be liable for any damage caused by the loss
    of data stored in the Company's server equipment or other telecommunication
    facilities. Users shall back up their data at their own risk.<br />
    (Disclaimer)<br />
    Article 13 We may change the features of the Service from time to time.
    Contents, services and software are subject to change without notice.<br />
    2 As a result of the changes described in the preceding paragraph, loss of
    data, functionality, or usefulness may occur. Users agree that the Company
    will make the changes described in the preceding paragraph based on the
    Service, and that the Company will not be liable for any loss of data,
    content, functionality, or usefulness unless otherwise provided by law.<br />
    ３ Even in the event that any problems or damages occur as a result of using
    the Service, the Company shall not be liable for them (including, but not
    limited to, compensation or indemnification).<br />
    ４ If a user causes damage to a third party through the use of the Service,
    the user shall be responsible for resolving the damage.<br />
    ５ The Company shall not be liable for any consequences arising from the use
    of the Service, regardless of the cause, such as malfunction or failure of
    equipment necessary for the provision of the Service, unauthorized intrusion
    by a third party, commercial disputes, compulsory dispositions based on laws
    and regulations.<br />
    ６ The Company shall not be liable for any damages incurred by users as a
    result of the discontinuation, suspension or restriction of use, or
    termination of provision of the Service in accordance with the provisions
    ser forth in the Article 8 (Discontinuation of the Service), Article 9
    (Suspension of the Service), and Article 10 (Termination of Provision of the
    Service).<br />
    ７　The Company shall not be liable for any damages caused by unforeseen
    circumstances such as cyber terrorism, natural disasters, or interference by
    third parties. (Cyber-terrorism refers to acts of terrorism in which
    computer systems in various fields, including national defense and public
    security, are infiltrated through computer networks to destroy or falsify
    data, thereby causing the important infrastructure of a nation or society to
    malfunction.<br />
    <br />
    Chapter 8 Handling of Personal Information<br />
    (Handling of Personal Information)<br />
    Article 14 The Company shall acquire all information such as surveys
    answered by users based on the Service (hereinafter referred to as "Response
    Information").<br />
    ２　The user agrees that the Company may use the Response Information as
    statistical information that does not identify the individual for the
    purposes specified below.<br />
    (1) Confirmation of survey results, analysis, and other matters necessary to
    conduct marketing research<br />
    (2) Matters necessary to implement product and solution development and
    modification<br />
    (3) Matters necessary for the implementation of seminars, events, campaigns,
    etc.<br />
    (4) Distribution of targeted advertising<br />
    (5) Matters necessary for conducting research and surveys<br />
    (6) Development and improvement of ad serving models, purchase prediction
    models, and other marketing solutions<br />
    (7) Re-research and additional diagnostics<br />
    (8) Other matters incidental or related to the above<br />
    ３　The Company may provide the Response Information to a third party that
    has a contractual relationship with the Company as information that cannot
    be used to directly identify specific individuals for the purposes described
    in the preceding paragraph.<br />
    <br />
    Chapter 9 Maintenance<br />
    (User’s Responsibility)<br />
    Article 15 When a user is unable to use the Service, the user shall confirm
    that there is no failure in the self-owned terminal equipment using the
    Service, and then request the Company to repair it.<br />
    2 Upon request from the User, the Company will conduct a test at the Sleep
    Deviation Score for Biz office and inform the User of the results.<br />
    <br />
    Chapter 10 Miscellaneous Provisions<br />
    (Limitation of Consent)<br />
    Article 16 In the event that the Company receives a request for construction
    or other work from a user, the Company may not accept the request if it is
    technically difficult to accept the request or if it is extremely difficult
    to maintain the service or otherwise interferes with the execution of the
    Company's business. In this case, the Company will notify the user of the
    reason. However, if there is a separate provision in these Terms of Use,
    that provision shall apply. (Obligations of the Subscriber for Use)<br />
    Article 17 Users shall take care to keep the user ID granted by the Company
    with the care of a good manager.<br />
    ２ Users shall, at their own responsibility, maintain and manage their own
    terminal equipment, communication lines and other equipment necessary to use
    the Service.<br />
    (Matters stipulated in laws and regulations)<br />
    Article 18 In the provision or use of the Service, matters stipulated in
    laws and regulations shall be governed by such laws and regulations.<br />
    (Governing Law)<br />
    Article 19 The formation, validity, interpretation, and performance of the
    Terms shall be governed by the laws of Japan.<br />
    (Resolution of Disputes)<br />
    Article 20 In the event that any dispute arises regarding any provision of
    the Terms or any matter not stipulated herein, both parties shall consult in
    good faith and resolve the dispute as amicably as possible.<br />
    ２　The Tokyo District Court shall be the exclusive court of first instance
    for any disputes related to these Terms of Use.<br />
    (Elimination of Antisocial Forces)<br />
    Article 21 The user represents that he or she does not fall under any of the
    following items, and confirms that he or she will not fall under any of the
    following items in the future. <br />
    (1) If it or any of its officers (directors, executive officers, or
    corporate auditors) is a crime group (Article 2, Item 2 of the Act on
    Prevention of Unjust Acts by Organized Crime Group Members (Act No. 77 of
    1991)), a member of a crime group (Article 2, Item 6 of the Act on
    Prevention of Unjust Acts by Organized Crime Group Members), a person for
    whom five years have not elapsed since the time when he/she ceased to be a
    member of a crime group, or a person who has a close relationship with a
    crime group or a member of a crime group (hereinafter referred to
    individually or collectively as a "Member of Crime Group")<br />
    (2) It is recognized that the business it conducts is under the control of
    Member of Crime Group<br />
    (3) With respect to the business that it conducts, it is recognized that it
    uses a Member of Crime Group for the purpose of using the power of the
    Member of Crime Group and seeking unjustified profit on property, or that it
    engages Member of Crime Group for the purpose of using the power of Member
    of Crime Group　<br />
    (4) It is recognized that the Company itself is involved in providing funds,
    favors, or unfair preferential treatment to the Member of Crime Group<br />
    (5) The use of the Service promotes the activities of Member of Crime Group
    or contributes to the operation of organized crime groups.<br />
    ２ In the event that a User falls under any of the following items, the
    Company may immediately discontinue the provision of this Service without
    any notice or demand.<br />
    (1) When the applicant violates Paragraph 1.<br />
    (2) When a person commits any of the following acts by himself/herself or a
    third party.<br />
    (i) Violent demands against the Company or its contractors<br />
    (ii) Unreasonable demands against the Company or its subcontractors that go
    beyond legal responsibility<br />
    (iii) Threatening words or violent acts against the Company or its
    subcontractors<br />
    (iv) Acts of spreading rumors or using deception or force to damage the
    credibility of the Company or its subcontractors, or to interfere with the
    business of the Company or its subcontractors.<br />
    (5) Any other acts equivalent to the preceding items.<br />
    ３ In the event that the Company suspends the provision of this service
    pursuant to the provisions of the preceding paragraph, the Company shall not
    be liable to compensate the user for any damages incurred.<br />
    <br />
    (Notice)<br />
    Article 22 Users shall notify the Company of their name (company name,
    name), address, contact information, contact person, and contact person
    contact information, and shall notify the Company of any changes. The
    Company shall not be liable for any damages incurred by the user due to
    failure to notify.<br />
    <!-- eslint-able -->
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.text {
  max-width: 100%;
  white-space: pre-line;
  font-size: 13px;
}
</style>